import { forwardRef } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

const LdsRadio = forwardRef(function LdsRadio(
  {
    id,
    name,
    value,
    required = false,
    label,
    disabled = false,
    error = false,
    className,
    labelClassName,
    ...rest
  },
  ref
) {
  return (
    <label
      className={cn(
        'lds-check-label',
        {
          disabled,
        },
        labelClassName
      )}
    >
      <input
        className={cn(
          'lds-radio',
          {
            disabled,
            error,
          },
          className
        )}
        id={id}
        required={required}
        type="radio"
        name={name}
        value={value}
        disabled={disabled}
        aria-invalid={error || null}
        aria-required={error || null}
        {...rest}
        ref={ref}
      />
      {label}
    </label>
  );
});

LdsRadio.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
};

export default LdsRadio;
